function Notification({ message }) {
    return (
        <div className="toast">
            {message}
        </div>
    );
}

export default Notification;